<template>
  <div>
    <div class="columns is-multiline dashboard-div" v-if="visible">
      <div class="column" :class="{'is-8':isAdmin, 'is-12':!isAdmin}" v-if="value">
        <!-- 서비스 운영 가이드 -->
        <div class="columns is-multiline">
          <!--<service-guide v-if="showServiceGuide"></service-guide>-->
          <!--<template v-if="checkServiceVersion(2)">
            <div class="column is-full">
              <div class="box">
                <div class="panel-header">
                  <div class="panel-title">오늘 주문 전환 현황</div>
                  <div v-if="isAdmin">
                    <lp-selector-drop-down :data.sync="partners"
                                           :selectVal="tabPartnerId"
                                           @onSelect="onChange"
                                           placeholder="파트너 이름으로 검색"
                                           width="200px"
                                           listAlign="center"
                                           style="display:inline-block;"></lp-selector-drop-down>
                  </div>
                </div>
                &lt;!&ndash; 패키지 선택 탭 &ndash;&gt;
                <div class="panel-tab-1" v-if="value.pack_panels.length>1">
                  <div class="unselect panel-tab-item-1"
                       :class="{'panel-tab-item-1-selected': panel.package === selectedPanel.package}"
                       v-for="(panel,idx) in value.pack_panels" :key="'pack-'+idx"
                       @click="selectedPanel=panel">
                    <img :src="svgSrc(panel.icon)" :alt="panel.package_kor">
                    <div>{{ panel.package_kor }}</div>
                  </div>
                </div>

                <div class="panel-content">
                  &lt;!&ndash; 오늘 매출 현황 &ndash;&gt;
                  <template v-if="selectedPanel.daily.order">
                    <div class="size-13 weight-500" style="background-color:white;padding-bottom:8px;color:#989898">오늘 매출 현황</div>
                    <div class="grid-daily">
                      <div class="unselect grid-item-daily order" @click="routerPush(selectedPanel.daily.order.url)">
                        <div>
                          <div class="grid-daily-title">주문({{ selectedPanel.daily.order.count }}건)</div>
                          <div class="grid-daily-price">
                          <span class="lp-count">{{ selectedPanel.daily.order.price|currencyNum }}</span>
                          <span class="size-16">원</span>
                        </div>
                        </div>
                      </div>
                      <div class="unselect grid-item-daily pay" @click="routerPush(selectedPanel.daily.pay.url)">
                        <div>
                          <div class="grid-daily-title">결제({{ selectedPanel.daily.pay.count }}건)</div>
                          <div class="grid-daily-price">
                          <span class="lp-count">{{ selectedPanel.daily.pay.price|currencyNum }}</span>
                          <span class="size-16">원</span>
                        </div>
                        </div>
                      </div>
                      <div class="unselect grid-item-daily refund" @click="routerPush(selectedPanel.daily.refund.url)">
                        <div>
                          <div class="grid-daily-title">환불({{ selectedPanel.daily.refund.count }}건)</div>
                          <div class="grid-daily-price">
                          <span class="lp-count">{{ selectedPanel.daily.refund.price|currencyNum }}</span>
                          <span class="size-16">원</span>
                        </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  &lt;!&ndash; 주문 관리 &ndash;&gt;
                  <template v-if="selectedPanel.order_manages.length>0">
                    <div class="size-13 weight-500" style="padding-top:16px;padding-bottom:8px;color:#989898">주문 관리</div>
                    <div :style="grid(selectedPanel.order_manages.length)">
                      <div v-for="(orderItem,idx) in selectedPanel.order_manages" :key="'order-item-'+idx"
                           class="unselect lp-panel-box" @click="routerPush(orderItem.url)">
                        <div class="panel-daily-title">{{ orderItem.name }}</div>
                        <div class="lp-content-box-data-1 lp-count">{{ orderItem.count }}</div>
                      </div>
                    </div>
                  </template>
                  &lt;!&ndash; 취소/환불 관리 &ndash;&gt;
                  <template v-if="selectedPanel.refund_manages.length>0">
                    <div class="size-13 weight-500" style="padding-top:16px;padding-bottom:8px;color:#989898">취소/환불 관리</div>
                    <div :style="grid(selectedPanel.refund_manages.length)">
                      <div v-for="(refundItem,idx) in selectedPanel.refund_manages" :key="'refund-item-'+idx"
                           class="lp-panel-box" @click="routerPush(refundItem.url)">
                        <div class="panel-daily-title">{{ refundItem.name }}</div>
                        <div class="lp-content-box-data-1 lp-count primary">{{ refundItem.count }}</div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </template>-->

          <template>
            <!-- 전체, 파트너별 선택 탭 -->
            <div v-if="isAdmin" class="column is-full flex" style="padding:12px">
              <div class="unselect tab-item" :class="{'tab-item-selected': selectedTab===0}" @click="clickTab(0)">전체</div>
              <div class="unselect tab-item" :class="{'tab-item-selected': selectedTab===1}" @click="clickTab(1)">파트너별</div>
              <div v-if="selectedTab===1">
                <div class="select-partner">
                  <select v-model="tabPartnerId" @change="res=>onChange(res, 'conversion')">
                    <option v-for="partner in partners" :key="'partner-'+partner.value"
                            :value="partner.value">{{ partner.name }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="column is-12">
              <inner-view :show-shadow="stopAdmin">
                <!-- 패키지 선택 탭 -->
                <div class="panel-tab" v-if="value.pack_panels.length>1">
                  <div class="unselect panel-tab-item"
                       :class="{'panel-tab-item-selected': panel.package === selectedPanel.package}"
                       v-for="(panel,idx) in value.pack_panels" :key="'pack-'+idx"
                       @click="selectedPanel=panel">{{ panel.package_kor }}</div>
                </div>
                <!-- 오늘 매출 현황 -->
                <template v-if="selectedPanel.daily.order">
                  <div class="lp-dashboard-title">오늘 매출 현황</div>
                  <div class="lp-dashboard-content unselect">
                    <div class="lp-panel-box column is-4" @click="routerPush(selectedPanel.daily.order.url)">
                      <div class="panel-daily-title">주문({{ selectedPanel.daily.order.count }}건)</div>
                      <div class="panel-daily-price">{{ selectedPanel.daily.order.price|currency }}</div>
                    </div>
                    <div class="lp-panel-box column is-4" @click="routerPush(selectedPanel.daily.pay.url)">
                      <div class="panel-daily-title">결제({{ selectedPanel.daily.pay.count }}건)</div>
                      <div class="panel-daily-price">{{ selectedPanel.daily.pay.price|currency }}</div>
                    </div>
                    <div class="lp-panel-box column is-4" @click="routerPush(selectedPanel.daily.refund.url)">
                      <div class="panel-daily-title">환불({{ selectedPanel.daily.refund.count }}건)</div>
                      <div class="panel-daily-price">{{ selectedPanel.daily.refund.price|currency }}</div>
                    </div>
                  </div>
                </template>
                <!-- 주문 관리 -->
                <template v-if="selectedPanel.order_manages.length>0">
                  <div class="lp-dashboard-title">주문 관리</div>
                  <div class="lp-dashboard-content unselect wrap">
                    <div v-for="(orderItem,idx) in selectedPanel.order_manages" :key="'order-item-'+idx"
                         class="lp-panel-content">
                      <div class="lp-panel-box" @click="routerPush(orderItem.url)">
                        <div class="lp-content-box-title">{{ orderItem.name }}</div>
                        <div class="lp-content-box-data">{{ orderItem.count }}</div>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 취소/환불 관리 -->
                <template v-if="selectedPanel.refund_manages.length>0">
                  <div class="lp-dashboard-title">취소/환불 관리</div>
                  <div class="lp-dashboard-content unselect wrap">
                    <div v-for="(refundItem,idx) in selectedPanel.refund_manages" :key="'refund-item-'+idx"
                         class="lp-panel-content">
                      <div class="lp-panel-box" @click="routerPush(refundItem.url)">
                        <div class="lp-content-box-title">{{ refundItem.name }}</div>
                        <div class="lp-content-box-data">{{ refundItem.count }}</div>
                      </div>
                    </div>
                  </div>
                </template>
              </inner-view>
            </div>
          </template>
          <!-- 문의/답변 관리 -->
          <div class="column is-full" v-if="cs">
            <inner-view :show-shadow="stopAdmin">
              <div class="box">
                <div class="panel-header">
                  <div class="panel-title">오늘 CS 현황</div>
                  <div v-if="isAdmin">
                    <lp-selector-drop-down :data.sync="partners"
                                           :selectVal="csPartnerId"
                                           @onSelect="res=>onChange(res, 'cs')"
                                           placeholder="파트너 이름으로 검색"
                                           width="200px"
                                           listAlign="center"
                                           style="display:inline-block;"></lp-selector-drop-down>
                  </div>
                </div>

                <div class="panel-content">
                  <div :style="gridCs()">
                    <template v-for="csKey in Object.keys(cs)">
                      <div v-if="cs[csKey]" :key="`cs-${csKey}`"
                           class="lp-content-box-1"
                           @click="$router.push(getPath(cs[csKey].url))">
                        <div class="lp-content-box-title-1">{{ cs[csKey].label }}</div>
                        <div class="lp-count">{{ cs[csKey].count|currencyNum }}</div>
                        <template v-if="cs[csKey].reply_stand !== undefined">
                          <div class="lp-reply-wrapper" style="margin:12px 0 2px 0">답변대기
                            <span class="reply-count primary">{{ cs[csKey].reply_stand }}</span></div>
                          <div class="lp-reply-wrapper">답변완료
                            <span class="reply-count">{{ cs[csKey].reply_success }}</span></div>
                        </template>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </inner-view>
          </div>
        </div>

        <!-- 주요 현황 -->
        <template v-if="chartData && chartData.chart">
          <div class="columns is-multiline">
            <div class="column is-full">
              <div class="box">
                <div class="panel-header">
                  <div class="panel-title">오늘 사용자 참여 전환 Funnel 현황</div>
                </div>
                <div class="panel-content">
                  <div :style="grid(chartData.chart.dataset.length)">
                    <div v-for="(data, d_idx) in chartData.chart.dataset" :key="`data-${d_idx}`">
                      <div class="chart-label">
                        <div :style="chartBg(data)"></div>
                        <div>{{ data.label }}</div>
                      </div>
                      <div :style="chartColor(data)" class="chart-count">{{ data.data.slice(-1)[0]|currencyNum }}</div>
                    </div>
                  </div>
                  <!-- 차트 -->
                  <div class="lp-chart-box">
                    <chart :data="chartData.chart" :height="300" v-if="chartData.chart"></chart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <panel-today-popular></panel-today-popular>
        <!--<template v-if="checkServiceVersion(2)">
            &lt;!&ndash; 주문이 가장 많은 상품 TOP 5 &ndash;&gt;
            <div class="column is-full" v-if="value.populate.length>0">
              <inner-view :show-shadow="stopAdmin">
                <div class="box">
                  <div class="panel-header">
                    <div class="panel-title">
                      주문이 가장 많은 상품 TOP 5<span style="font-size:12px;margin-left:8px">*최근 1개월 기준</span>
                    </div>
                  </div>
                  <div class="panel-content" style="display: block">
                    <div v-for="(item,idx) in value.populate" :key="'populate-item-'+idx"
                         class="unselect card-top-product" @click="clickPopulate(item)">
                      <div>
                        <img style="width:36px;height:36px;object-fit: cover" :src="item.first_img">
                      </div>
                      <div style="flex:1;padding:0 8px">
                        <div class="card-top-product-name">{{ item.name }}</div>
                        <div class="card-top-product-partner-name">{{ item.partner_name }}</div>
                      </div>
                      <div class="has-text-centered">
                        <div>주문수</div>
                        <div>{{ item.count }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </inner-view>
            </div>
          </template>
          <template v-else>
            &lt;!&ndash; 주문이 가장 많은 상품 TOP 5 &ndash;&gt;
            <div class="column is-6" v-if="value.populate.length>0">
              <inner-view :show-shadow="stopAdmin">
                <div class="lp-dashboard-title">주문이 가장 많은 상품 TOP 5<span style="font-size:12px;margin-left:8px">*최근 1개월 기준</span></div>
                <div class="lp-dashboard-content" style="display: block">
                  <div v-for="(item,idx) in value.populate" :key="'populate-item-'+idx"
                       class="unselect card-top-product" @click="clickPopulate(item)">
                    <div>
                      <img style="width:36px;height:36px;object-fit: cover" :src="item.first_img">
                    </div>
                    <div style="flex:1;padding:0 8px">
                      <div class="card-top-product-name">{{ item.name }}</div>
                      <div class="card-top-product-partner-name">{{ item.partner_name }}</div>
                    </div>
                    <div class="has-text-centered">
                      <div>주문수</div>
                      <div>{{ item.count }}</div>
                    </div>
                  </div>
                </div>
              </inner-view>
            </div>
          </template>-->

        <!-- 게시판 관리 / Top5 게시물 -->
        <div class="columns is-multiline" v-if="value.board && value.post">
          <!-- 게시판 관리 -->
          <div class="column is-6">
            <div class="lp-dashboard-title">게시판 관리</div>
            <div style="background-color: white;padding:16px 0">
              <div v-for="(board,idx) in value.board" :key="'board-'+idx" style="display:flex;padding:0 12px">
                <div style="width:100%;display:flex;align-items:center;margin:4px 0;cursor:unset;border:1px solid #eee">
                  <div style="width:40%;font-size:16px;padding-left:12px;font-weight:bold;color:#575757">{{ board.title }}</div>
                  <div style="width:20%;text-align: center">
                    <div class="lp-content-box-title">신규 게시물</div>
                    <div class="lp-content-box-data">{{ board.board_count }}</div>
                  </div>
                  <div style="width:20%;text-align: center">
                    <div class="lp-content-box-title">새 댓글</div>
                    <div class="lp-content-box-data" style="color:#575757">{{ board.comments }}</div>
                  </div>
                  <div style="width:20%;text-align: center">
                    <div class="lp-content-box-title">공유</div>
                    <div class="lp-content-box-data" style="color:#575757">{{ board.shared_count }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Top5 -->
          <div class="column is-6">
            <div class="lp-dashboard-title">Top 5 게시물</div>
            <div class="lp-dashboard-content lp-background"
                 style="display: block;padding:16px;cursor:pointer"
                 @click="clickPost(post)"
                 v-for="(post,idx) in value.post"
                 :key="'post-'+idx">
              <div class="flex space-between">
                <div>{{ post.title }}</div>
                <div class="lp-light-grey">{{ post.board_title }}</div>
              </div>
              <div class="flex">
                <div class="lp-light-grey" style="margin-right:8px">조회수 {{ post.hits }}</div>
                <div class="lp-light-grey">댓글 {{ post.comments }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 내 서비스 구성현황 -->
        <div class="columns is-multiline" v-if="showServiceGuide">
          <service-package-panel></service-package-panel>
        </div>
      </div>

      <!--<div class="column is-4" v-if="isAdmin">
        &lt;!&ndash; 서비스 정보 &ndash;&gt;
        <div class="columns is-multiline">
          <service-info :value="value"></service-info>
        </div>

        &lt;!&ndash; 1:1 문의 목록 &ndash;&gt;
        &lt;!&ndash;<div class="columns is-multiline" v-if="isAdmin">
          <div class="column is-full">
            <div class="box">
              <div class="panel-header">
                <div class="panel-title">솔루션 이용 문의</div>
                <div class="lp-more" @click="clickCustomerInquiry">더보기</div>
              </div>
              <div class="panel-content">
                <template v-if="customer.length>0">
                  <div v-for="(n,idx) in customer" :key="'customer-'+idx"
                       @click="clickCustomerInquiryDetail(n.id)" v-if="customer.length>0 && idx < 5">
                    <div class="flex space-between ">
                      <div class="lp-light-black" style="flex:2;">{{ n.title }}</div>
                      <div class="lp-light-grey">{{ n.created_time }}</div>
                    </div>
                    <div class="lp-light-grey" style="text-align: right;font-size: 12px;">
                      <div v-if="n.status===0">신규요청</div>
                      <div v-else-if="n.status===1">요청확인</div>
                      <div v-else-if="n.status===2">진행중</div>
                      <div v-else-if="n.status===3">답변완료</div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="size-12">
                    문의 내용이 없습니다.
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>&ndash;&gt;

        &lt;!&ndash; 공지사항 &ndash;&gt;
        &lt;!&ndash;<div class="columns is-multiline" v-if="isAdmin">
          <div class="column is-full">
            <div class="box">
              <div class="panel-header">
                <div class="panel-title">런치팩 공지사항</div>
                <div class="lp-more" @click="clickNotice">더보기</div>
              </div>
              <div class="panel-content">
                <div v-for="(n,idx) in notice"
                     :key="`notice-${idx}`"
                     class="flex space-between"
                     style="padding-bottom:8px"
                     @click="clickNoticeDetail(n.id)" v-if="notice.length>0 && idx < 5">
                  <div class="lp-light-black" style="flex:2;">{{ n.title }}</div>
                  <div class="lp-light-grey">{{ n.created_time }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>&ndash;&gt;
      </div>-->
    </div>

  </div>
</template>

<script>
  import chart from '../../../LineChart.js'
  import ServiceGuide from "./ServiceGuide";
  import InnerView from "../../layout/InnerView";
  import ServicePackagePanel from "./ServicePackagePanel";
  import ServiceInfo from "./ServiceInfo";

  import LpSelectorDropDown from "../../module/common/LpSelectorDropDown";
  import PanelTodayPopular from "./PanelTodayPopular";
  export default {
    layout: 'Main',
    name: 'Dashboard',
    components: {
      PanelTodayPopular,
      LpSelectorDropDown,
      ServiceInfo,
      ServicePackagePanel,
      InnerView,
      ServiceGuide,
      chart
    },
    computed: {
      noticeTitle() {
        let title = '런치팩 공지사항'
        if(this.checkServiceVersion(2)) {
          title = '솔루션 공지사항'
        }
        return title
      },
      inquiryTitle() {
        let title = '런치팩 1:1 문의'
        if(this.checkServiceVersion(2)) {
          title = '솔루션 이용 문의'
        }
        return title
      },
      orderType() {
        let text = '주문방식(팩)';
        if(this.serviceType===1) text = '주문방식(테마)';
        return text;
      },
      showServiceGuide() {
        return this.$store.getters.mode === 'admin' && this.checkServiceVersion(2);
      },
    },
    created() {
      this.getData();
      this.getTodayCs();
      this.getChartData();
      if (this.isAdmin) {
        this.getPartners();
        // this.getNotice();
        this.getCustomerInquiry();
      }
    },
    data() {
      return {
        selectedTab: 0,
        tabPartnerId: 0,
        partners: [],
        value: {},
        // 차트
        chartData: {},
        // 공지사항
        notice: [],
        // 1:1 문의
        customer: [],
        visible: false,
        selectedPanel: undefined,
        cs: undefined,
        csPartnerId: 0
      }
    },
    methods: {
      chartBg(item) {
        return `width:10px;height:10px;background-color:${item.backgroundColor}`;
      },
      chartColor(item) {
        return `color:${item.backgroundColor}`;
      },
      getPartners() {
        this.$axios.get(this.getUrl('partner/simple')).then(res=>{
          let partners = res.data;
          if(this.checkServiceVersion(2)) {
            partners.splice(0, 0, {label:'전체 파트너', name:'전체 파트너', value: 0})
          }
          this.partners = partners
          this.tabPartnerId = this.partners.length > 0 ? this.partners[0].value : 0;
        });
      },
      clickTab(i) {
        if (this.selectedTab !== i) {
          this.selectedTab = i;
          this.getData();
          this.getChartData();
        } else {
          this.selectedTab = i;
        }
      },
      onChange(res, type) {
        if(type==='cs') {
          this.csPartnerId = res.value;
          this.getTodayCs();
        } else {
          this.tabPartnerId = res.value;
          this.getData();
        }
        // this.getChartData();
      },
      getTodayCs() {
        let url = 'dashboard/cs';
        if(this.csPartnerId !== 0) {
          url += `?partner_id=${this.csPartnerId}`;
        }
        this.$axios.get(this.getUrl(url)).then(res=> {
          if(res.status===200) {
            this.cs = res.data;
          }
        })
      },
      getData() {
        let url = 'dashboard';
        if(this.tabPartnerId !== 0) {
          url += `?partner_id=${this.tabPartnerId}`;
        }
        this.$axios.get(this.getUrl(url)).then(res => {
          if (res.status === 200) {
            this.value = res.data;
            if (!this.selectedPanel)
              this.selectedPanel = this.value.pack_panels[0];
            else {
              let sel = this.value.pack_panels.filter(item => {
                return item.package === this.selectedPanel.package
              });
              if (sel.length > 0) {
                this.selectedPanel = sel[0];
              } else {
                this.selectedPanel = this.value.pack_panels[0];
              }
            }
            this.visible = true;
          }
        })
      },
      getChartData() {
        let url = 'dashboard/chart';
        if (this.selectedTab === 1 && this.tabPartnerId !== 0) {
          url += `?partner_id=${this.tabPartnerId}`;
        }
        this.chartData = {};
        this.$axios.get(this.getUrl(url)).then(res => {
          if (res.status === 200) {
            this.chartData = res.data;
          }
        })
      },
      getCustomerInquiry() {
        this.$axios.get('admin/launchpack/inquiry/customer').then(res => {
          this.customer = res.data.data;
        })
      },
      clickCustomerInquiry() {
        if (this.isAdmin) {
          this.$router.push(this.getPath('launchpack/inquiry/customer'));
        }
      },
      clickCustomerInquiryDetail(id) {
        if (this.isAdmin) {
          this.$router.push(this.getPath('launchpack/inquiry/customer/create?id=' + id));
        }
      },
      getNotice() {
        // let key = this.$store.getters.getServiceSetting.service_key;
        /*this.$axios.get(this.masterBackendUrl + 'public/launchpack/notice', {
          params: {
            key: key
          }
        }).then(res=>{
          this.notice = res.data.data;
        })*/
        this.$axios.get('admin/launchpack/notice').then(res => {
          this.notice = res.data.data;
        })
      },
      clickNotice() {
        if (this.isAdmin) {
          this.$router.push(this.getPath('launchpack/notice'));
        }
      },
      clickNoticeDetail(id) {
        if (this.isAdmin) {
          this.$router.push(this.getPath('launchpack/notice/create?id=' + id));
        }
      },
      clickPost(post) {
        this.$router.push(this.getPath(`board/${post.board_id}/post?title=${post.board_title}`));
      },
      clickPopulate(item) {
        this.routerPush(`product/create?id=${item.id}`);
      },
      grid(num) {
        return {
          display: 'grid',
          gridTemplateColumns: `repeat(${num}, 1fr)`
        }
      },
      gridCs() {
        return this.grid(
          ['product_call', 'product_inquiry', 'product_review', 'personal_inquiry'].filter(i => this.cs[i]).length
        );
      }
    }
  }
</script>



<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .lp-content-box
  .lp-more
  .lp-notice-content
    cursor pointer

  .lp-chart-box
    background-color white
    padding-top 24px
    padding-bottom 10px

  .lp-dashboard-title1
    padding 16px
    background-color white
    color $main
    font-weight 300
    font-size 16px
    border-bottom 1px solid $gray2

  .lp-dashboard-title
    padding 16px
    background-color white
    color #989898
    font-size 16px

  .lp-dashboard-content
    padding 16px
    padding-top 0
    display flex
    background-color white

  .lp-content-box
    width 46%
    border 1px solid #eee
    margin 0 2% 8px 2%

  /*width 50%*/
  /*border 1px solid #eee*/
  /*margin 0 4px*/

  .lp-content-box:hover
    background-color #eee

  .lp-light-black
  .lp-light-grey
    font-size 12px

  .lp-light-black
    color #333333

  .lp-light-grey
    color #989898

  .lp-btn-setting
    cursor pointer
    margin-left 12px

  .lp-content-box-title
    text-align center
    padding-top 16px
    font-size 12px

  .lp-content-box-data
    padding 16px
    text-align center
    color $primary
    font-size 26px
    font-weight bold

  .lp-content-box-1
    padding 16px 24px
    border 1px solid #eee
    border-left 0
    cursor pointer
    user-select none

  .lp-content-box-1:first-child
    border-left 1px solid #eee
    border-top-left-radius 6px
    border-bottom-left-radius 6px
  .lp-content-box-1:last-child
    border-top-right-radius 6px
    border-bottom-right-radius 6px

  .lp-content-box-1:hover
    background-color #eee

  .lp-content-box-title-1
    font-size 14px
    color #787878
    margin-bottom 8px

  .lp-content-box-data-1
    font-size 18px
    font-weight 600
  .primary
    color $primary

  .chart-label
    display flex
    align-items center
    gap 0 4px
    font-size 13px
    color #4A4A4A
  .chart-count
    font-size 14px

  .lp-dashboard-table
    width 100%
    background-color white

  .lp-dashboard-table th
  .lp-dashboard-table td
    text-align center !important
    font-size 12px

  .lp-dashboard-table th
    font-weight unset

  .lp-dashboard-table tr
    height 40px
    line-height 40px

  .lp-service-charge
    border-radius 24px
    padding 4px
    font-size 12px
    background-color #eee
    text-align center
    color #333

  .lp-more
    font-size 12px
    line-height 12px
    color $sub3
    font-weight 400

  .lp-notice-content
    background-color white
    padding 16px

  .lp-site-analytics
    background-color rgb(255, 120, 77)
    width 124px
    height 32px
    text-align center
    line-height 32px
    font-size 12px
    color white
    border-radius 3px

  .lp-background:hover
    background-color #eee

  /*.dashboard-div
    margin-bottom 80px !important

  @media(max-width:768px)
    .dashboard-div
      margin-bottom 578px !important*/


  .tab-item
    padding 4px 12px
    margin-right 8px

  .tab-item-selected
    background-color #ff5722
    color white
    border-radius 30px

  .select-partner
    background white
    border 1px solid #ddd
    padding 4px 12px
    border-radius 30px

    select
      border 0

  .panel-tab
    background-color white
    display flex
    flex-wrap wrap
    padding 12px

  .panel-tab-item
    padding 4px 12px
    font-size 14px
    color #777

  .panel-tab-item-selected
    background-color #ff5722
    border-radius 30px
    color white

  .panel-tab-1
    display flex
    background-color #f5f5f5

  .panel-tab-item-1
    flex 1
    padding 4px 12px
    font-size 14px
    color #363636
    font-weight 400
    display flex
    align-items center
    justify-content center
    text-align center
    gap 4px

  .panel-tab-item-1-selected
    background-color white
    font-weight 500
    padding 10px
    display flex
    align-items center
    justify-items center

  .lp-panel-box
    border 1px solid #eee
    border-right 0
    cursor pointer
    padding 16px 24px

  .lp-panel-box:first-child
    border-top-left-radius 6px
    border-bottom-left-radius 6px
  .lp-panel-box:last-child
    border-right 1px solid #eee
    border-top-right-radius 6px
    border-bottom-right-radius 6px

  .lp-panel-box:hover
    background-color #f5f5f5

  .panel-daily-title
    font-size 14px
    margin-bottom 4px

  .panel-daily-price
    font-size 26px

  .lp-panel-content
    padding 4px
    width 20%

  @media (max-width: 768px)
    .panel-daily-title
      font-size 12px

    .panel-daily-price
      font-size 16px

    .lp-panel-content
      width 50%

  .card-top-product
    display flex
    padding 6px 20px 6px 0
    border-bottom 1px solid #dddddd
    align-items center
    font-size 12px
    color #4a4a4a

  .card-top-product-partner-name
    color #9b9b9b

  .card-top-product:hover
    background-color #f5f5f5

  .lp-reply-wrapper
    font-size 13px
    .reply-count
      margin-left 4px
      font-weight 700

  .lp-count
    font-size 18px
    line-height 18px
    font-weight 600

  .box
    padding 0

  .panel-header
    padding 16px 20px
    display flex
    align-items center
    justify-content space-between
    border-bottom 1px solid #eeeeee

  .panel-title
    color $main
    font-size 21px
    font-weight 300

  .panel-content
    padding 20px

  .grid-daily
    display grid
    grid-template-columns repeat(3, 1fr)
    gap 8px

    .grid-item-daily
      padding 0 24px
      height 85px
      display flex
      align-items center
      border-radius 6px
    .order
      background-color #FFEAD2
      color #7A060B
    .pay
      background-color #E6DFFF
      color #1C127A
    .refund
      background-color #F5F5F5
      color #363636
    .grid-daily-title
      font-size 14px
      font-weight 500
      line-height 22px
    .grid-daily-price
      font-size 20px
      font-weight 500
      line-height 20px
      margin-top 8px
</style>
